var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "b",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 155.91 127.56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".k{fill:url(#g);}.l{fill:url(#i);}.m,.n{fill:none;}.o,.p{fill:#fff;}.n{stroke:#fff;stroke-linejoin:round;stroke-width:1.24px;}.p{fill-rule:evenodd;}.q{clip-path:url(#h);}.r{clip-path:url(#j);}.s{clip-path:url(#e);}.t{clip-path:url(#f);}.u{clip-path:url(#d);}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "d"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "m",
    width: 155.91,
    height: 127.56
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "e"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "m",
    x: -41.71,
    y: -4.32,
    width: 235.05,
    height: 192.32
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "f"
  }, /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M42.89,11.59c-9.26,4.87-18.84,9.9-29.51,11.21-1.03,.12-1.94,.69-2.49,1.53-.57,.85-.75,1.91-.48,2.91,8.86,31.73,21.65,56.4,63.87,95.85,.21,.19,.41,.32,.59,.42l.56,.28c.4,.15,.82,.23,1.23,.23,.46,0,.92-.09,1.26-.24l.38-.16,.17-.12c.15-.09,.37-.22,.6-.44,42.19-39.42,54.99-64.09,63.85-95.82,.27-1,.1-2.06-.46-2.88-.57-.86-1.49-1.42-2.51-1.55-10.69-1.31-20.26-6.35-29.54-11.23C99.39,5.79,88.98,.31,76.66,.31s-22.73,5.47-33.77,11.28"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x1: -0.31,
    y1: 128.11,
    x2: 1.2,
    y2: 128.11,
    gradientTransform: "translate(55.63 -9996.98) scale(78.52)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d7b849"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d7b849"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#be9f56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#f7eeb1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#fff8bd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#be9f56"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "h"
  }, /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M19.9,33.03l-.3,.1c7.97,28.14,19.39,50.17,57.11,85.51,37.68-35.3,49.12-57.35,57.01-85.67l-.16-.02-.05,.08c-.32-.16-32.3-16.62-56.81-16.62S20.22,32.87,19.9,33.03"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    x1: -0.18,
    y1: 128.17,
    x2: 1.32,
    y2: 128.17,
    gradientTransform: "translate(33.58 -9634.85) scale(75.7)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d1b556"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d1b556"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#be9f56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#bfa159"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#eae2a9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#d8c788"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#be9f56"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "j"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "m",
    x: -31.03,
    y: -4.32,
    width: 213.68,
    height: 192.32
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "c"
  }, /*#__PURE__*/React.createElement("g", {
    className: "u"
  }, /*#__PURE__*/React.createElement("g", {
    className: "s"
  }, /*#__PURE__*/React.createElement("g", {
    className: "t"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "k",
    x: -14.11,
    y: -28.61,
    width: 181.55,
    height: 181.55,
    transform: "translate(-21.5 72.41) rotate(-45)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "q"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "l",
    x: 19.6,
    y: 16.41,
    width: 114.12,
    height: 102.23
  })), /*#__PURE__*/React.createElement("g", {
    className: "r"
  }, /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M76.71,16.41c-24.52,0-56.49,16.46-56.81,16.62l-.3,.1c7.97,28.14,19.39,50.18,57.11,85.51,37.68-35.3,49.12-57.34,57.01-85.67l-.16-.02-.05,.09c-.32-.17-32.3-16.62-56.81-16.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "M109.44,74.18H43.75V32.05H109.44v42.13Zm-64.33-1.36h62.98V33.41H45.1v39.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M52.88,55.13c0,8.2,2.32,12.43,10.28,12.43,7.4,0,10.06-5.35,10.06-12.9v-17.41h2.62v18.58c0,9.24-5.42,13.86-13.61,13.86-4.6,0-7.68-1.06-10.11-3.25-2.93-2.63-3.29-6.8-3.35-10.52v-18.67h4.1v17.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "M95.44,67.87c-7.35,0-12.49-5.71-12.49-14.67,0-7.92,4.25-14.86,12.82-14.86,4.35,0,7.6,2.62,8.64,3.72v-3.96c-2.71-.97-5.62-1.55-8.47-1.55-9.8,0-17.54,5.99-17.54,16.49s6.14,16.65,16.4,16.65c3.26,0,6.78-.6,9.61-2.24v-2.62c-1.63,1.17-4.94,3.05-8.97,3.05"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUc);
export default __webpack_public_path__ + "static/media/uc.e1e743d6031733a226bd731e9b9037f9.svg";
export { ForwardRef as ReactComponent };